// =============================================================================
// Screenshot lightbox — clicking any captioned figure (.aa-step-figure__media)
// zooms it in an overlay. Global: covers figures inside steps sections and
// standalone image-showcase blocks alike.
// =============================================================================

function openFigure(media) {
	const img = media.querySelector("img");
	if (!img || !img.src) {
		return;
	}

	const figure = media.closest(".aa-step-figure");
	const capEl = figure ? figure.querySelector(".aa-step-figure__cap") : null;
	const caption = capEl ? capEl.textContent.trim() : "";

	const overlay = document.createElement("div");
	overlay.className = "aa-steps-lightbox";
	overlay.setAttribute("role", "dialog");
	overlay.setAttribute("aria-modal", "true");
	overlay.setAttribute("aria-label", caption || "Screenshot");

	const frame = document.createElement("div");
	frame.className = "aa-steps-lightbox__frame";
	const big = new Image();
	big.src = img.src;
	big.alt = caption || img.alt || "";
	frame.appendChild(big);

	const bar = document.createElement("div");
	bar.className = "aa-steps-lightbox__bar";
	if (caption) {
		const cap = document.createElement("span");
		cap.className = "aa-steps-lightbox__caption";
		cap.textContent = caption;
		bar.appendChild(cap);
	}
	const hint = document.createElement("span");
	hint.className = "aa-steps-lightbox__hint";
	hint.textContent = "Click anywhere to close";
	bar.appendChild(hint);

	overlay.appendChild(frame);
	overlay.appendChild(bar);
	document.body.appendChild(overlay);
	document.body.style.overflow = "hidden";

	// Fade/scale in on the next frame so the CSS transition runs.
	void overlay.offsetWidth;
	overlay.classList.add("is-open");

	let closing = false;
	const onKey = (e) => {
		if (e.key === "Escape") {
			close();
		}
	};
	const close = () => {
		if (closing) {
			return;
		}
		closing = true;
		overlay.classList.remove("is-open");
		document.body.style.overflow = "";
		document.removeEventListener("keydown", onKey);
		// Remove from the DOM once the fade-out finishes (with a safety net).
		overlay.addEventListener(
			"transitionend",
			(e) => {
				if (e.target === overlay && e.propertyName === "opacity") {
					overlay.remove();
				}
			},
			{ once: true },
		);
		setTimeout(() => overlay.remove(), 400);
	};

	overlay.addEventListener("click", close);
	document.addEventListener("keydown", onKey);
}

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".aa-step-figure__media").forEach((media) => {
		media.addEventListener("click", () => openFigure(media));
	});
});
